export const CMD_WITHDRAW = '/cco';
